<div class="plateImageContainer" *ngIf="!hideDetails">
  <fs-image-lightbox-viewer
    class="lightboxViewer"
    [images]="lightboxImages"
    [isVisible]="false"
    [isDetailsView]="true"
    [isRightSidenavOpen]="true"
    (isClosed)="onLightBoxClosed()"
    [plate]="plate"
    [croppedImageUrl]="croppedImageUrl"
    [plateText]="plate?.plate"
    [plateId]="plate?.id"
  >
    <sn-text-icon-button
      detailsViewHeaderContent
      [class.marked-for-review]="isMarkedForReview"
      class="detailsViewDarkbackgroundBtn"
      (click)="toggleMarkForReview()"
      [label]="(isMarkedForReview ? 'alpr.actions.markedForReview' : 'alpr.actions.markForReview') | t"
      [icon]="isMarkedForReview ? 'bookmark' : 'bookmark_border'"
    >
    </sn-text-icon-button>
    <sn-text-icon-button
      fullscreenHeaderContent
      [class.marked-for-review]="isMarkedForReview"
      (click)="toggleMarkForReview()"
      [label]="(isMarkedForReview ? 'alpr.actions.markedForReview' : 'alpr.actions.markForReview') | t"
      [icon]="isMarkedForReview ? 'bookmark' : 'bookmark_border'"
    >
    </sn-text-icon-button>
  </fs-image-lightbox-viewer>
</div>

<div class="vehicleDetailsContainer">
  <div class="vehicleDetailsCard">
    <img *ngIf="plateImageUrl" [src]="plateImageUrl" class="plateImage" />
    <div *ngIf="!plate?.plateImageUrl" class="plateImageFallback">—</div>

    <div class="plateNumberContainer">
      <ng-container *ngFor="let i of [0, 1, 2, 3, 4, 5, 6, 7, 8]">
        <div class="plateChar" [class.lastPlateChar]="i === 8">
          {{ getPaddedPlateChars()[i] || '' }}
          <!-- Copy Icon in last char box -->
          <button
            *ngIf="i === 8 && plate?.plate"
            class="copyIconButton"
            mat-icon-button
            [cdkCopyToClipboard]="plate?.plate"
            (click)="$event.stopPropagation()"
            [matTooltip]="'alpr.actions.copyPlate' | t"
          >
            <sn-icon class="copyIcon">content_copy</sn-icon>
          </button>
        </div>
      </ng-container>
    </div>

    <div class="plateState">
      {{
        plate?.displayState
          ? (plate?.displayState | fsStateConvert : 'short') +
            ' - ' +
            (plate?.displayState | fsStateConvert : 'long')
          : '—'
      }}
    </div>
  </div>

  <div class="details-container">
    <!-- Timestamp and More section -->
    <div class="info-row-container">
      <div class="info-row">
        <span class="timestamp">
          <strong>{{
            plate?.createdTimestamp
              ? (plate?.createdTimestamp | fsFormatDate : 'timeFirstNoAmPm')
              : '—'
          }}</strong>
        </span>
        <button mat-icon-button [matMenuTriggerFor]="lprOptions" (click)="$event.stopPropagation()">
          <mat-icon>more_horizon</mat-icon>
        </button>
      </div>

      <!-- Vehicle Details section -->
      <div class="vehicle-details">
        <div class="detail-item">
          <span class="label">{{ 'alpr.vehicleDetails.body' | t }}</span>
          <span class="value">
            {{ plate?.vehicleBody || '—' }}
            <ng-container *ngIf="plate?.vehicleBody && plate?.vehicleBodyConfidence">
              ({{ plate?.vehicleBodyConfidence | fsNumber : '1.0-2' }}%)
            </ng-container>
          </span>
        </div>
        <div class="detail-item">
          <span class="label">{{ 'alpr.hotlist.vehicle.make' | t }}</span>
          <span class="value">
            {{ plate?.vehicleMake || '—' }}
            <ng-container *ngIf="plate?.vehicleMakeConfidence">
              ({{ plate?.vehicleMakeConfidence | fsNumber : '1.0-2' }}%)
            </ng-container>
          </span>
        </div>

        <!-- Color alone on second row, adding a class to make it span both columns via CSS -->
        <div class="detail-item full-width">
          <span class="label">{{ 'common.color' | t }}</span>
          <span class="value">
            <span>{{ plate?.vehicleColor ? (plate?.vehicleColor | fsFormatColor) : '—' }}</span>
            <ng-container *ngIf="plate?.vehicleColorConfidence">
              ({{ plate?.vehicleColorConfidence | fsNumber : '1.0-2' }}%)
            </ng-container>
          </span>
        </div>

        <!-- Plate Type and Plate State now on third row -->
        <div class="detail-item">
          <span class="label">{{ 'alpr.vehicleDetails.plateType' | t }}</span>
          <span class="value">{{ plate?.type ? (plate?.type | titlecase) : '—' }}</span>
        </div>
        <div class="detail-item">
          <span class="label">{{ 'alpr.hotlist.vehicleDetails.plateState' | t }}</span>
          <span class="value">{{
            plate?.displayState ? (plate?.displayState | fsStateConvert : 'long') : '—'
          }}</span>
        </div>

        <!-- Sharing agency information -->
        <div *ngIf="lprSharingEnabled && plate?.isSharedRecord" class="detail-item full-width">
          <span class="label">{{ 'vehicleIntelligence.alprSearch.form.sharedRecords.sharedByLabel' | t}}</span>
          <span class="value">{{ plate?.agencyInfo?.name ? plate?.agencyInfo?.name : '—' }}</span>
        </div>
      </div>
    </div>

    <!-- Actions section -->
    <div class="actions">
      <button mat-stroked-button (click)="onSearchPlate()" [disabled]="!isSearchReasonValid()">
        {{ 'alpr.actions.searchThisPlate' | t }}
      </button>
    </div>
  </div>
</div>

<mat-menu #lprOptions="matMenu">
  <button mat-menu-item (click)="sendToVault(plate)">
    <span>{{ 'alpr.actions.sendToVault' | t }}</span>
  </button>
  <button *ngIf="shouldShowDownloadButton" [disabled]="!contextImageUrl" mat-menu-item (click)="downloadImage(plate)">
    <span>{{ 'alpr.actions.downloadImage' | t }}</span>
  </button>
  <button
    [disabled]="!plate?.plateImageUrl || plate?.plateImageKey"
    mat-menu-item
    (click)="downloadPlate(plate)"
  >
    <span>{{ 'alpr.actions.downloadPlate' | t }}</span>
  </button>
  <button *ngIf="plate?.geometry?.coordinates" mat-menu-item (click)="showOnMap(plate)">
    <span>{{ 'alpr.actions.showOnMap' | t }}</span>
  </button>
</mat-menu>
